import { MicrosoftTemplate, CustomTemplate } from 'types/template';
import WizardButtonWrapper from '../../Wizard/WizardButtonWrapper';
import { isMicrosoftTemplate } from 'utils/templateGuards';
import TemplateReview from '../TemplateReview';

export default function LaunchTemplate({
  selectedTemplate,
  onModalClose,
  onClick,
}: {
  selectedTemplate: MicrosoftTemplate | CustomTemplate;
  onModalClose: () => void;
  onClick: () => void;
}) {
  const shouldUseSimpleUI = isMicrosoftTemplate(selectedTemplate);
  return (
    <div className="">
      <div className="d-flex flex-column p-2">
        {shouldUseSimpleUI ? (
          <div>
            <span className="text-muted fs-7">Template Name</span>
            <span className="fs-5 fw-normal d-block">
              {selectedTemplate.label}
            </span>
          </div>
        ) : (
          <TemplateReview
            description={selectedTemplate?.description}
            channels={selectedTemplate?.channels}
            label={selectedTemplate.label}
          />
        )}
      </div>
      <WizardButtonWrapper
        onModalClose={onModalClose}
        buttonProps={[
          {
            onClick,
            text: 'Launch',
            isPrimary: true,
          },
        ]}
      />
    </div>
  );
}
